import { axiosPost } from '@/utils/httpUtil'
import { API_URL } from '@/utils/constant/app.constants'

/**
 * @description: httpSuppMoCmAuthmngMenuAuthRetrieveUserInfo (사용자정보조회)
 */
export const httpSuppMoCmAuthmngMenuAuthRetrieveUserInfo = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/cm/authmng/menu-auth/retrieve-user-info',
    data: pdata
  })
}

/**
 * @description: httpSuppMoCmCmmCommRetrieveCommCd (공통코드 조회)
 * @param {string} grpCd 그룹코드
 */
export const httpSuppMoCmCmmCommRetrieveCommCd = (pdata) => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/cm/cmm/comm/retrieve-comm-cd',
    data: pdata
  })
}

/**
 * @description: httpCheckPasswdExpr (사용자 비밀번호 만료일 체크)
 */
export const httpSuppMoCmAuthmngUserCheckPasswdExpr = () => {
  return axiosPost({
    url: API_URL + '/supp/api/mo/cm/authmng/user/check-passwd-expr'
  })
}
